// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WI-z","isFullWidth":"XI-z","landingPageVideo":"YI-z","play":"ZI-z","iframeVideo":"_I-z","playHidden":"aJ-z","fullwidth":"bJ-z"};